<template>
    <div class="elle-team-grid">
        <div class="container">
            <div class="grid4">
                <CardsPerson v-for="item in persons" :key="item.id" :person="item" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        persons?: CmsItem[];
    }>(),
    {
        persons: () => []
    }
);

const persons = computed(() => props.persons);
</script>
